import SelectField from "@/components/common/select";
import { useResolution } from "../context";

const RESOLUTION_OPTIONS = [
  { label: "Aprobado", value: "approved" },
  { label: "Denegado", value: "denied" },
  { label: "Improcedente", value: "unfair" },
  { label: "Cancelado", value: "canceled" },
];

export const ResolutionSelector = () => {
  const { status, setStatus } = useResolution();
  return (
    <SelectField
      label="Resolución otorgada"
      required
      name="resolution"
      placeholder="Seleccionar resolución..."
      options={RESOLUTION_OPTIONS}
      value={status}
      onChange={(option) => {
        setStatus(option || "");
      }}
    />
  );
};
